import { css } from '@emotion/react'
import styled from '@emotion/styled'
// eslint-disable-next-line import/no-unresolved
import SVGLoader, { SVGIconType } from '@src/components/svg/SVGLoader/SVGLoader'
import { NavLink, useLocation } from 'react-router-dom'

type SideBarItemProps = {
	icon: SVGIconType
	text: string
	to: string
	matches?: string[]
}

const SideBarItem = ({ icon, text, to, matches }: SideBarItemProps) => {
	const location = useLocation()
	const isActive = matches
		? matches.some((match) => location.pathname === match)
		: location.pathname === to

	return (
		<NavItem>
			<NavLink css={linkStyle(isActive)} to={to}>
				<IconBlock>
					<SVGLoader name={icon} />
				</IconBlock>
				<MenuName>{text}</MenuName>
			</NavLink>
		</NavItem>
	)
}

const NavItem = styled.li``

const MenuName = styled.span`
	font-size: 1.4rem;
	font-weight: 600;
	line-height: 1.9rem;
	margin-left: 1.1rem;
	letter-spacing: 0.02rem;
	color: #a4a6b3;
`

const linkStyle = (isActive: boolean) => css`
	display: flex;
	align-items: center;
	text-decoration: none;
	padding: 1rem 0;
	padding-left: 4.4rem;

	${isActive &&
	css`
		background-color: #eaecf9;
		& > * {
			color: #353d4a;
		}

		svg {
			color: #353d4a;
		}
	`}
`

const IconBlock = styled.div`
	width: 1.8rem;
	height: 1.8rem;

	svg {
		color: #a4a6b3;
	}
`

export default SideBarItem
